import { useSelector } from 'react-redux';
import Global from '../store/global-selectors';
import { useOrderRoutingFeatureGate } from '../feature-gates/use-order-routing-feature-gate';

export const useEnableFulfillmentProviderFilter = () => {
  const isOrderRoutingEnabled = useOrderRoutingFeatureGate();
  const fulfillmentProviders = useSelector(Global.selectSellerActiveFulfillmentProviders);
  return isOrderRoutingEnabled && fulfillmentProviders.length > 0;
};
